import { Notifications } from '@mantine/notifications';
import { useIsMobile } from './useIsMobile';

/** Toasts: bottom-right on desktop, top on mobile (handoff rule). */
export function ResponsiveNotifications() {
  const isMobile = useIsMobile();
  return <Notifications position={isMobile ? 'top-center' : 'bottom-right'} limit={3} />;
}
